module.exports = __webpack_public_path__ + "img/ball_4_transparent.5fa3e53d.png";